/**
 * Eco Traders navigation enhancement. Native <details> provides the baseline;
 * this custom element synchronises desktop/mobile state and closes disclosures.
 * No framework, animation loop, catalogue fetch or app-global state is required.
 * disconnectedCallback removes listeners when the Shopify editor reloads a section.
 */
(() => {
  'use strict';
  // Section scripts can be evaluated again by editor integrations.
  if (customElements.get('etr-header')) return;
  class EtrHeader extends HTMLElement {
    connectedCallback() {
      this.menu = this.querySelector('.etr-menu');
      if (!this.menu || this.controller) return;
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.wide = window.matchMedia('(min-width: 1100px)');
      this.syncViewport = () => {
        this.dataset.wide = String(this.wide.matches);
        this.menu.open = this.wide.matches;
        this.closeDepartments();
      };
      this.syncViewport();
      this.wide.addEventListener('change', this.syncViewport, { signal });
      // One open department keeps desktop panels from overlapping; mobile remains inline.
      this.querySelectorAll('.etr-department').forEach((department) => {
        department.addEventListener('toggle', () => {
          if (department.open) this.closeDepartments(department);
        }, { signal });
      });
      this.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;
        const department = event.target.closest('.etr-subcategory[open], .etr-department[open]');
        if (department) {
          department.open = false;
          department.querySelector('summary').focus();
        } else if (!this.wide.matches && this.menu.open) {
          this.menu.open = false;
          this.menu.querySelector('summary').focus();
        }
      }, { signal });
      document.addEventListener('click', (event) => {
        if (!this.contains(event.target)) {
          this.closeDepartments();
          if (!this.wide.matches) this.menu.open = false;
        }
      }, { signal });
      // Close a desktop panel after keyboard focus leaves the header.
      this.addEventListener('focusout', (event) => {
        if (this.wide.matches && event.relatedTarget && !this.contains(event.relatedTarget)) this.closeDepartments();
      }, { signal });
    }
    /** Close sibling panels without changing the currently opening disclosure. */
    closeDepartments(except) {
      this.querySelectorAll('.etr-department[open]').forEach((item) => {
        if (item !== except) item.open = false;
      });
    }
    /** Avoid duplicate document/media listeners after an editor section replacement. */
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
    }
  }
  customElements.define('etr-header', EtrHeader);
})();
